module.exports = __webpack_public_path__ + "static/wirelessPro.2d538cca.png";


//////////////////
// WEBPACK FOOTER
// ./src/sections/signupPage/readerCompare/images/wirelessPro.png
// module id = 1707
// module chunks = 168707334958949